import { useState } from 'react';
import { startAuthentication } from '@simplewebauthn/browser';
import { api } from '../lib/api';

interface Props {
  onEnrollStart: () => void;
  onAuthenticated: () => Promise<void> | void;
}

export function Login({ onEnrollStart, onAuthenticated }: Props) {
  const [mode, setMode] = useState<'passkey' | 'password'>('passkey');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function passkeyLogin(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const optionsJSON = await api.loginBegin(email.trim().toLowerCase());
      const response = await startAuthentication({ optionsJSON });
      await api.loginFinish(response);
      await onAuthenticated();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed');
    } finally {
      setBusy(false);
    }
  }

  async function passwordLogin(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.passwordLogin(email.trim().toLowerCase(), password);
      onEnrollStart();
    } catch {
      setError('Invalid email or temporary password');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="center">
      <div className="card">
        <h1>
          <span className="brand-mark">AIStor</span> Demo Hub
        </h1>
        <p className="muted">MinIO field demo dashboard</p>

        {mode === 'passkey' ? (
          <form onSubmit={passkeyLogin}>
            <label htmlFor="email">Email</label>
            <input id="email" type="email" autoComplete="username webauthn" required value={email} onChange={(e) => setEmail(e.target.value)} />
            <button type="submit" disabled={busy}>
              {busy ? 'Waiting for passkey…' : 'Sign in with passkey'}
            </button>
            <button type="button" className="link" onClick={() => { setMode('password'); setError(null); }}>
              First time? Use your temporary password
            </button>
          </form>
        ) : (
          <form onSubmit={passwordLogin}>
            <label htmlFor="email2">Email</label>
            <input id="email2" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
            <label htmlFor="pw">Temporary password</label>
            <input id="pw" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            <button type="submit" disabled={busy}>
              {busy ? 'Checking…' : 'Continue to passkey setup'}
            </button>
            <button type="button" className="link" onClick={() => { setMode('passkey'); setError(null); }}>
              Back to passkey sign-in
            </button>
          </form>
        )}

        {error && <p className="error">{error}</p>}
      </div>
    </main>
  );
}
